<template>
    <v-container fluid fill-height class="background">
      <v-slide-y-transition mode="out-in">
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-4">
              <v-toolbar dark color="secondary" class="elevation-0">
                <v-toolbar-title><img src="../../assets/logoDark.png" height="50px"/></v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-form class="p-4">
                <v-card-actions>
                  <v-alert :value="authError" type="error"> You have entered an incorrect username or password. Please try again.</v-alert>
                </v-card-actions>
                <v-card-text>
                  <v-text-field v-model="userLogin.email" prepend-icon="email" name="login" label="Email" type="text"></v-text-field>
                  <v-text-field v-model="userLogin.password" id="password" prepend-icon="lock" name="password" label="Password" type="password"></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="signIn" color="primary">Login</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-flex>
        </v-layout>
      </v-slide-y-transition>
    </v-container>   
</template>

<script>
  import { auth } from '../../firebaseInit'
  export default {
    data () {
      return {
        userLogin: {
          email: null,
          password: null
        }
      }
    },
    created () {
    // check for authentication token
      auth.onAuthStateChanged(user => {
        if (user) {
          this.$store.dispatch('autoSignIn', user)
        }
      })
    },
    computed: {
      user () {
        return this.$store.getters.user
      },
      authError () {
        return this.$store.getters.authError
      }
    },
    watch: {
      user (value) {
        if (value !== null && value !== undefined) {
          this.$router.push('/home')
        }
      }
    },
    methods: {
      signIn () {
        this.$store.dispatch('signUserIn', this.userLogin)
      }
    }
  }
</script>

<style scoped>
.background {
  background-image: url('../../assets/loginImage.jpg');
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
body,
html {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/authentication/Login.vue